import { useQuery } from 'react-query'
import { useIntl } from 'react-intl'
import { requestAllDistributorsExtend } from '../../requests/requests'
import { configStaleTime } from '../../constants'
import { BreadcumbsSection } from '../../components/BreadcumbsSection'
import { CustomerWithID } from '../../models/allOrdersWithFilters'
import { SingleWholesaler } from './SingleWholesaler'
import { useEffect } from 'react'
import { usePaginationForWrapper } from '../../hooks/usePaginationForWrapper'
import { PaginationWrapper } from '../../components/PaginationWrapper'

export function ListUserWholesaler() {
  const intl = useIntl()
  const {
    isLoading,
    error,
    data,
  } = useQuery('listAllDistributorsExtend', () => requestAllDistributorsExtend(), {
    refetchOnWindowFocus: false,
    staleTime: configStaleTime,
  })

  const paginationObj = usePaginationForWrapper(data?.data ? data.data : [], 20)

  useEffect(() => {
    paginationObj.refreshPagination()
  }, [data?.data])

  return (
    <>
      <BreadcumbsSection title={intl.formatMessage({ id: 'LIST_WHOLESALERS.TITLE' })} breadcrumbItems={[intl.formatMessage({ id: 'MENU.DASHBOARD' }), intl.formatMessage({ id: 'LIST_WHOLESALERS.TITLE' })]}>
      </BreadcumbsSection>
      <div className='card card-flush py-4 flex-row-fluid overflow-hidden'>
        <div className='card-body pt-0'>
          <div className='table-responsive'>
            <table className='table align-middle table-row-dashed fs-6 gy-5 mb-0'>
              <thead>
                <tr className='text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0'>
                  <th className='min-w-175px'>
                    {intl.formatMessage({ id: 'LIST_USERS.NAME' })}
                  </th>
                  <th className='min-w-70px'>
                    {intl.formatMessage({ id: 'LIST_USERS.EMAIL' })}
                  </th>
                  <th className='min-w-70px'>
                    {intl.formatMessage({ id: 'LIST_USERS.ALLOWED_LOGIN' })}
                  </th>
                  <th className='min-w-70px'>
                    {intl.formatMessage({ id: 'LIST_USERS.CREATED_AT' })}
                  </th>
                  <th className='min-w-70px'>
                    {intl.formatMessage({ id: 'LIST_USERS.UPDATED_AT' })}
                  </th>
                  <th className='min-w-70px'>
                    {intl.formatMessage({ id: 'LIST_USERS.LAST_LOGIN' })}
                  </th>
                  <th className='min-w-70px'>
                    {intl.formatMessage({ id: 'LIST_USERS.LAST_PURCHASE' })}
                  </th>
                </tr>
              </thead>
              <tbody className='fw-semibold text-gray-600'>
                {isLoading && (
                  <tr>
                    <td colSpan={3}>{intl.formatMessage({ id: 'FETCH.LOADING' })}</td>
                  </tr>
                )}
                {error ? (
                  <tr>
                    <td colSpan={3}>{intl.formatMessage({ id: 'FETCH.ERROR' })}</td>
                  </tr>
                ) : (
                  false
                )}
                {
                  paginationObj && paginationObj.currentItems && paginationObj.currentItems.map((user: CustomerWithID) => (
                    <SingleWholesaler
                      user={user}
                      key={user.id}
                    />
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {paginationObj &&
        <div className='card card-flush py-4 flex-row-fluid overflow-hidden mt-5'>
          <PaginationWrapper {...paginationObj} />
        </div>}
    </>
  )
}
